import React from "react";
import { connect } from "react-redux";
import { updateMMPLUserDetails, getMMPLUsersDetails, getMMPLUsersList } from "../Actions/UserManagementAPI";
import { getShipnameList } from "../Actions/HelpersAPI";
import { Multiselect } from "multiselect-react-dropdown";
import swal from "sweetalert";
import { hideLoader, showLoader } from "../Actions/PageLoaderAPI";
import { getUsersList, getTeamForUser } from "../Actions/CommonAPI";
import Axios from "axios";
import API from "../helpers/api";

let searchData = {
    email: '',
    PageNumber: 1,
    PageSize: 5
};

let userkey = JSON.parse(localStorage.getItem("currentUser"));
class EditUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            UserInfo: {
                userId: 0,
                emailId: "",
                isAdmin: false,
                mmplShips: [],
                modifiedBy: "",
                isDeleted: false
            },
            teamEmail: [],
            chosenUserid: [],
            ships: [],
            Users: [],
        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.UpdateData = this.UpdateData.bind(this);
        this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this);
        this.onSelectChange = this.onSelectChange.bind(this);
        this.onRemoveChange = this.onRemoveChange.bind(this);
        this.handleTeam = this.handleTeam.bind(this);
        this.removeTeam = this.removeTeam.bind(this);
    }

    componentDidMount() {
        const { dispatch, match } = this.props;
        const { params } = match;
        const { id } = params;
        dispatch(getShipnameList());
        dispatch(getMMPLUsersList(searchData));
        dispatch(getUsersList());
        dispatch(getTeamForUser(id));
        dispatch(getMMPLUsersDetails(id))
        let url = `${API.GetUserTeams}?userId=` + id;
        let userurl = `${API.UserAPI}?userid=${id}`;
        Axios.get(userurl)
            .then((response) => {
                this.state.UserInfo.userId = response.data.userId;
                this.state.UserInfo.emailId = response.data.emailId;
                this.state.UserInfo.isAdmin = response.data.isAdmin;
                this.setState({});
            })
            .catch((error) => {
                console.log("error", error);
            })
        Axios.get(url)
            .then((response) => {
                let templist = [];
                if (response && response.data && response.data.length > 0) {
                    response.data.map((item) => {
                        let _id = JSON.stringify(item.userId)
                        if (id !== _id) {
                            let temp = { "userId": item.userId, "mail": item.emailId }
                            templist.push(temp);
                            this.state.chosenUserid.push(item.userid)
                        }
                    })
                    console.log(this.state.teamEmail)
                    this.setState({
                        teamEmail: templist
                    });
                }
            })
    }

    handleTeam(list, item) {
        this.setState({
            chosenMailid: list.map(x => x.userId)
        }, () => {
            console.log(this.state.chosenMailid)
        })

    }
    removeTeam(list, item) {
        console.log("list", list)
        console.log("item", item)
        this.setState({
            chosenMailid: list.map(x => x.userId)
        }, () => {
            console.log(this.state.chosenMailid)
        })

    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { dispatch, UserInformation, UserDetails } = nextProps;
        // if (UserDetails && UserDetails !== "") {
        //     prevState.UserInfo.userId = UserDetails.userId;
        //     prevState.UserInfo.emailId = UserDetails.emailId;
        //     prevState.UserInfo.isAdmin = UserDetails.isAdmin;
        //     dispatch({ type: "UserDetails", data: "" });
        // }
        if (UserInformation && UserInformation !== "") {
            prevState.Users = UserInformation.mmplUserShips;
            prevState.ships = UserInformation.mmplUserShips.map(r => { return (r.shipName) });
            dispatch({ type: "getUserDetailsSuccess", data: "" });
        }
    }

    handleInputChange(e) {
        this.state.UserInfo.emailId = e.target.value;
        this.setState({});
    }

    handleCheckBoxChange(e) {
        if (e.target.checked) {
            this.state.UserInfo.isAdmin = true;
            this.setState({});
        } else {
            this.state.UserInfo.isAdmin = false;
            this.setState({});
        }
    }

    UpdateData() {
        const { dispatch, UsersList, isUserUpdated } = this.props;
        let teamsurl = `${API.CreateTeams}`;
        //  let user = UsersList.users.filter(r => { return r.emailId === this.state.UserInfo.emailId });
        // let Users = this.state.Users;
        // if (Users.length != 0) {
        //     this.state.ships.map((val, index) => {
        //         Users[index].shipName = val;
        //     });
        // }
        // let item = this.state.ships.map(r => {
        //     let payload = {};
        // payload.mmplUserShipId = r.mmplUserShipId;
        //     payload.shipName = r;
        //     return payload;
        // })
        // this.state.UserInfo.mmplShips = item;
        // if (Users.length != 0) {
        // }
        // else {
        //     this.state.UserInfo.mmplShips = this.state.ships.toString();
        // }

        //   if (user.length === 0) {
        let teamsData = {
            modifiedBy: userkey.email,
            userId: this.state.UserInfo.userId,
            listOfTeammatesId: this.state.chosenMailid
            // teammateId: this.state.chosenUserid
        };
        let userInfo = {
            userId: this.state.UserInfo.userId,
            emailId: this.state.UserInfo.emailId,
            isAdmin: this.state.UserInfo.isAdmin,
            isDeleted: false,
            mmplShips: this.state.ships ? this.state.ships.toString() : "",
            modifiedBy: ""
        }
        if (this.state.UserInfo.emailId !== "") {
            let url2 = `${API.userExist}?Mail=${this.state.UserInfo.emailId}&Id=${this.state.UserInfo.userId}`;
            Axios
              .get(url2, {
                headers: {
                  key: userkey.accessToken,
                },
              })
              .then((response) => {
                if (response.data === true) {
        dispatch(updateMMPLUserDetails(userInfo, teamsData));
        // Axios.put(teamsurl, teamsData, {
        //     headers: {
        //         key: userkey.accessToken,
        //     }
        // })
        // .then((response) => {
        //     console.log("res", response);
        // })
        // .catch((error) => {
        //     console.log("error", error);
        // })

        this.hideSidePanel();}
        else if (response.data === false) {
            swal(
              "Error!",
              "User already exist. Please change the email",
              "warning"
            );
            this.setState({ emailId: "" });
          }
          dispatch({
            type: "getUserExistListSuccess",
            data: response.data,
          });
        })
           .catch((error) => {
          dispatch({
            type: "getUserExistListFailure",
            data: "error",
          });
        });
    }else {
      swal("Error!", "Email is mandatory", "warning");
    }
        //  } else {
        //     swal('Error!', 'User already exist', 'warning');
        //     this.hideSidePanel();
        // }
    }

    onSelectChange(item) {
        this.setState({ ships: item });
    }

    onRemoveChange(item) {
        this.setState({ ships: item });
    }

    hideSidePanel = () => {
        //  this.props.dispatch({ type: "ShowSidePan", data: false });
        this.props.history.push(`/Home/Management/User`);
    };

    render() {
        const { ShipNameList, userData, teamUserData } = this.props;
        console.log("team email", this.state.teamEmail)
        console.log("team ship", this.state.ship)
        return (
            <div className="full-height">
                <div className="resource-list-auth-date row pt-3">
                    <div className="col-lg-12">
                        <div className="panel-box search-filter-box">
                            {/* <button
                                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                onClick={() => this.hideSidePanel()}
                            >
                                &larr; Return
                            </button> */}
                            <div className="card MM-card-header mt-2 mb-0" style={{ backgroundColor: "white", border: "0px" }}>
                                <div className="card-body">
                                    <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                                        Update User
                                    </h5>
                                </div>
                            </div>
                            <div className="search-filter-box">
                                <div className="row">
                                    <div className="col-lg-4">
                                        <label className="form-label">Email Id</label>
                                        <br></br>
                                        <input
                                            className="form-control"
                                            type="email"
                                            name="emailId"
                                            placeholder="Email Id"
                                            value={this.state.UserInfo.emailId}
                                            onChange={e => this.handleInputChange(e)}
                                        // readOnly
                                        ></input>
                                    </div>
                                    <div className="col-lg-2">
                                        <label className="form-label" >Is Admin</label><br></br>
                                        <input type="checkbox" name="isAdmin" checked={this.state.UserInfo.isAdmin} onChange={(e) => this.handleCheckBoxChange(e)}></input>
                                    </div>
                                    <div className={"col-lg-4"}>
                                        <label className="form-label">Team</label>
                                        <Multiselect options={userData} isObject={true}
                                            style={{ option: { "margin-right": 0, "display": "block", "font-weight": "normal" }, chips: { "background-color": "#1E3A8A" } }}
                                            onSelect={this.handleTeam}
                                            onRemove={this.removeTeam}
                                            selectedValues={this.state.teamEmail}
                                            displayValue="mail"
                                            closeIcon="cancel"
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-6">
                                        <label className="form-label" >Ship Name</label><br></br>
                                        <Multiselect options={ShipNameList} isObject={false}
                                            style={{ option: { "margin-right": 0, "display": "block", "font-weight": "normal" }, chips: { "background-color": "#1E3A8A" } }}
                                            onSelect={(item) => this.onSelectChange(item)}
                                            onRemove={(item) => this.onRemoveChange(item)}
                                            selectedValues={this.state.ships}
                                            placeholder={this.state.ships && this.state.ships.length ? "" : "Select"}
                                            closeIcon="cancel"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row py-3">
                                <div className="col-lg-12">
                                    <div className="search-btn-col" style={{ textAlign: "end" }}>
                                        <button
                                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                            type="submit"
                                            onClick={() => this.UpdateData()}
                                        >
                                            {" "}Update{" "}
                                        </button>
                                        <button
                                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                            type="button"
                                            onClick={() => this.hideSidePanel()}
                                        >
                                            {" "}Cancel{" "}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        UserDetails: state.UserManageReducer.UserDetails,
        ShipNameList: state.UserManageReducer.ShipNameList,
        UserInformation: state.UserManageReducer.UserInformation,
        UsersList: state.UserManageReducer.UsersList,
        userData: state.MMPLDashboardReducer.userData,
        teamUserData: state.MMPLDashboardReducer.teamUserData,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EditUser);
